<template>
  <div class="container-top" v-if="detail">
    <div class="pc">
      <div class="container padding-top-60">
        <div class="product-wrapper">
          <!-- 상품정보 좌 -->
          <div>
            <div class="card-img" :style="imgField(detail.img, 'pc')">
              <div class="card-exts" v-if="exts.length>0">
                <img v-for="(ext,idx) in exts" :key="`ext-${idx}`"
                     :src="`/static/icon/ext_${ext}.svg`">

              </div>
            </div>
          </div>
          <!-- 상세정보 우 -->
          <div>
            <div class="box-right">
              <div class="body5 sub3 unselect" @click="clickCategory">{{ detail.category2_name }}</div>
              <div class="subtitle3 main">{{ detail.title }}</div>
              <div class="body3 padding-top-8">{{ detail.content }}</div>
              <div class="flex-align" style="gap:16px;margin-top:16px">
                <div class="flex-align" style="gap:4px">
                  <star-rating :rating="detail.rate"
                               :readOnly="true"
                               active-color="#ff5722"
                               :star-size="12"
                               :increment="0.5"
                               :padding="1"
                               :star-points="[20,34, 30,40, 31,40, 32,40, 33,38, 33,37, 31,25, 39,18, 40,16, 40,15, 39,14, 38,13, 27,12, 22,1, 21,0, 20,0, 19,0, 18,1, 13,12, 2,13, 1,14, 0,15, 0,16, 1,18, 9,25, 7,37, 7,38, 8,40, 9,40, 10,40, 20,34]"
                               :show-rating="false"></star-rating>
                  <div class="body4-medium primary unselect"
                       @click="clickReview">{{ detail.reviews_count|currencyNum }}개 후기
                  </div>
                </div>
                <div class="flex-align" style="gap:4px">
                  <img src="/static/icon/u_eye.svg" class="svg-sub3" style="width:14px">
                  <div class="body4 sub3">조회수 {{ detail.visit|currencyNum }}</div>
                </div>
              </div>
              <div class="h6 main margin-top-20">
                <template v-if="detail.price.price_type === 0">
                  <span v-if="detail.price.is_discount" class="primary" style="margin-right:8px">{{ detail.price.discount_rate }}%</span>
                  {{ detail.price.sale_price|currencyNum }}<span class="body1">원<span v-if="detail.price.is_subscription">/월~</span></span>
                </template>
                <template v-else>
                  {{ detail.price.price_text }}
                </template>
              </div>
              <!-- 미리보기 버튼 -->
              <div class="button-group-preview" v-if="detail.preview_url">
                <button class="button is-primary-light2" @click="showMobilePreview">
                  <img src="/static/icon/u_mobile-android-alt.svg" alt="" class="unselect"
                       style="width:20px;height:20px">
                  <span class="body2-medium margin-left-12">모바일 미리보기</span>
                </button>
                <a :href="detail.preview_url" target="_blank">
                  <button class="button is-primary-light2">
                    <img src="/static/icon/fi_monitor.svg" alt="" class="unselect"
                         style="width:20px;height:20px">
                    <span class="body2-medium margin-left-12">데스크톱 미리보기</span>
                  </button>
                </a>
              </div>
              <trial-button v-if="detail.category2 === 59" :product="detail"></trial-button>
              <skin-button v-else-if="detail.category2 === 60" :product="detail"></skin-button>
              <template-button v-else-if="detail.category2 === 61" :product="detail"></template-button>
            </div>
            <div class="box-right margin-top-24" style="padding:20px 32px">
              <div class="flex-between" style="gap:16px">
                <img :src="detail.partner.img" alt="" class="img-partner">
                <div class="body2-medium main text-left" style="flex:1">{{ detail.partner.name }}</div>
                <div class="body3 sub2">{{ category_name }} <span class="primary">{{ detail.partner.product_count|currencyNum }}개</span>
                </div>
              </div>
              <div class="border-top-gray-3"></div>
              <div class="unselect flex-align" style="gap:6px" @click="$router.push('/inquiry_reg?type_id=20')">
                <img src="/static/icon/fi_sale.svg">
                <div class="body5 primary">런치팩에서 판매하고 싶으신가요?</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 상품 상세 -->
        <!-- 관련 상품 -->
        <block-related-product v-if="detail.related_products.length>0" :isTheme="true"
                               :products="detail.related_products"></block-related-product>
        <!-- 탭 -->
        <tab ref="tab" :menu="tabs" :style="`margin-top:${detail.related_products.length > 0 ? '40' : '100'}px`">
          <template v-slot:tab0>
            <div v-if="detail.imgs && detail.imgs.length>0" style="margin-top:64px;padding:0 75px">
              <div class="content-slide" v-if="detail.imgs">
                <slick ref="slick" :options="slickOptions">
                  <div v-for="(img, idx) in detail.imgs"
                       :key="'slide-'+idx" class="slick-img-outer">
                    <img :src="img" alt="" class="slick-img" :style="slickImg">
                  </div>

                </slick>
              </div>
            </div>
            <div class="sun-editor-editable content column is-12" id="anchor0" v-html="detail.info">{{ detail.info }}
            </div>
          </template>
          <template v-slot:tab1>
            <div class="content column is-12" style="margin-top:64px">
              <product-review></product-review>
            </div>
          </template>
          <template v-slot:tab2>
            <div class="content column is-12" style="margin-top:64px">
              <product-inquiry></product-inquiry>
            </div>
          </template>
        </tab>
      </div>
    </div>

    <div class="mobile">
      <div class="card-img" :style="imgField(detail.img, 'mobile')">
        <div class="card-exts" v-if="exts.length>0">
          <img v-for="(ext,idx) in exts.slice(0,5)" :key="`ext-${idx}`"
               :src="`/static/icon/ext_${ext}.svg`">
        </div>
      </div>
      <div class="container padding-top-16">
        <!-- 파트너 -->
        <div class="body6 sub3">{{ detail.category2_name }}</div>
        <div class="subtitle5 main" style="margin-top:6px">{{ detail.title }}</div>
        <div class="padding-top-8 sub2">{{ detail.content }}</div>

        <div class="flex-align" style="gap:16px;margin-top:16px">
          <div class="flex-align" style="gap:4px">
            <star-rating :rating="detail.rate"
                         :readOnly="true"
                         active-color="#ff5722"
                         :star-size="12"
                         :increment="0.5"
                         :padding="1"
                         :star-points="[20,34, 30,40, 31,40, 32,40, 33,38, 33,37, 31,25, 39,18, 40,16, 40,15, 39,14, 38,13, 27,12, 22,1, 21,0, 20,0, 19,0, 18,1, 13,12, 2,13, 1,14, 0,15, 0,16, 1,18, 9,25, 7,37, 7,38, 8,40, 9,40, 10,40, 20,34]"
                         :show-rating="false"></star-rating>
            <div class="body5-medium primary unselect"
                 @click="clickReview">{{ detail.reviews_count|currencyNum }}개 후기
            </div>
          </div>
          <div class="flex-align" style="gap:4px">
            <img src="/static/icon/u_eye.svg" class="svg-sub3" style="width:14px">
            <div class="body5 sub3">조회수 {{ detail.visit|currencyNum }}</div>
          </div>
        </div>
        <div class="body0-bold main margin-top-8">
          <template v-if="detail.price.price_type === 0">
            <span v-if="detail.price.is_discount" class="primary" style="margin-right:4px">{{ detail.price.discount_rate }}%</span>
            {{ detail.price.sale_price|currencyNum }}<span class="body3">원<span v-if="detail.price.is_subscription">/월~</span></span>
          </template>
          <template v-else>
            {{ detail.price.price_text }}
          </template>
        </div>

        <a class="mobile-preview" :href="detail.preview_url" target="_blank" v-if="detail.preview_url">
          <button class="button is-primary-light2 margin-top-24 body4"
                  style="width:100%;height:40px">미리보기
          </button>
        </a>
      </div>
      <div class="lp-divider-gray3 padding-top-24"></div>
      <div class="container padding-top-16">
        <trial-button v-if="detail.category2 === 59" :product="detail"></trial-button>
        <skin-button v-else-if="detail.category2 === 60" :product="detail"></skin-button>
        <template-button v-else-if="detail.category2 === 61" :product="detail"></template-button>

        <div class="box-right margin-top-24">
          <div class="flex-between" style="gap:16px">
            <img :src="detail.partner.img" alt="" class="img-partner">
            <div class="body2-medium main text-left" style="flex:1">{{ detail.partner.name }}</div>
            <div class="body3 sub2">{{ category_name }} <span class="primary">{{ detail.partner.product_count|currencyNum }}개</span>
            </div>
          </div>
          <div class="border-top-gray-3"></div>
          <div class="unselect flex-align" style="gap:6px" @click="$router.push('/inquiry_reg?type_id=20')">
            <img src="/static/icon/fi_sale.svg">
            <div class="body5 primary">런치팩에서 판매하고 싶으신가요?</div>
          </div>
        </div>

      </div>

      <!-- 관련 상품 -->
      <block-related-product v-if="detail.related_products.length>0" :isTheme="true"
                             :products="detail.related_products"></block-related-product>
      <!-- 상품 상세-->
      <div>
        <div class="lp-divider-gray3-12 margin-top-12"></div>
        <!-- 탭 -->
        <tab ref="mtab" :menu="tabs" anchor="mtabs" anchorTop="-59px">
          <template v-slot:tab0>
            <div v-if="detail.imgs && detail.imgs.length>0" class="content column is-12">
              <div class="content-slide" v-if="detail.imgs">
                <scroll-wrapper>
                  <div class="flex-align">
                    <template v-for="(img, idx) in detail.imgs">
                      <img :src="img" alt="" class="slick-img" style="width:260px;height:385px;margin:0 6px"
                           :key="'slide-'+idx">
                    </template>
                  </div>
                </scroll-wrapper>
              </div>
            </div>
            <div v-html="detail.info" class="sun-editor-editable padding-left-16 padding-right-16">{{ detail.info }}
            </div>
          </template>
          <template v-slot:tab1>
            <product-review></product-review>
          </template>
          <template v-slot:tab2>
            <product-inquiry></product-inquiry>
          </template>
        </tab>
      </div>
    </div>
  </div>

</template>

<script>
  import UserAPIMixin from "../../mixins/UserAPIMixin";
  import ProductInquiry from "./ProductInquiry";
  import Tab from "../module/Tab";
  import ScrollWrapper from "../module/ScrollWrapper";
  import TrialButton from "../component/TrialButton";
  import BlockRelatedProduct from "../component/BlockRelatedProduct";
  import ProductReview from "./ProductReview";
  import Slick from 'vue-slick'
  import StarRating from "vue-star-rating/src/star-rating";
  import TemplateButton from "../component/TemplateButton";
  import SkinButton from "../component/SkinButton";

  export default {
    name: "ThemeDetail",
    mixins: [
      UserAPIMixin
    ],
    components: {
      SkinButton,
      TemplateButton,
      ProductReview,
      BlockRelatedProduct,
      TrialButton,
      ScrollWrapper,
      Tab,
      ProductInquiry,
      Slick,
      StarRating
    },
    data() {
      return {
        tabs: [
          {id: 0, name: '서비스 안내'}, {id: 1, name: '후기'}, {id: 2, name: '이용문의'}
        ],
        // 상세 상품
        detail: undefined,
        slickOptions: {
          centerMode: false,
          variableWidth: false,
          infinite: true,
          autoplay: false,
          centerPadding: '20px',
          slidesToShow: 3,
          slidesToScroll: 1,
          speed: 600,
          prevArrow: '<div class="arrow-left"><img class="arrow-img" src="/static/icon/fi_chevron-left.svg" @click="prev"></div>',
          nextArrow: '<div class="arrow-right"><img class="arrow-img" src="/static/icon/fi_chevron-right.svg" @click="next"></div>',
          responsive: [
            {
              breakpoint: 767,
              settings: {
                autoplay: true,
                slidesToShow: 1,
                centerMode: true,
                dots: false,
                arrows: false
              }
            }
          ]
        },
      }
    },
    watch: {
      '$route'(n) {
        if (n.query.id) {
          this.getProductDetail();
        }
      }
    },
    created() {
      if (this.$route.query.id) {
        this.getProductDetail();

        if (this.isMobile) {
          this.slickOptions.variableWidth = false;
          this.slickOptions.centerMode = false;
          this.slickOptions.autoplay = true;
        }
      }
    },
    beforeDestroy() {
      //document.getElementById('ch-plugin').style.display = '';
    },
    mounted() {
      // setTimeout(() => {
      //   document.getElementById('ch-plugin').style.display = 'none';
      // }, 1000);
    },
    computed: {
      exts() {
        return this.detail && this.detail.params ?
          this.detail.params.find(i => i.name === '파일 종류') ?
            this.detail.params.find(i => i.name === '파일 종류').choice_items.filter(i =>
              this.detail.params.find(i => i.name === '파일 종류').value_select.indexOf(i.id) > -1).map(i => i.name.toLowerCase())
            : []
          : [];
      },
      category_name() {
        if(this.detail) {
          if(this.detail.category2_name.indexOf('테마')>-1) {
            return '테마';
          } else if(this.detail.category2_name.indexOf('스킨')>-1) {
            return '스킨';
          } else {
            return '템플릿';
          }
        } else {
          return '';
        }
      },
      slickImg() {
        if (window.innerWidth > 500) {
          let width = 318;
          let height = 483;
          let margin = '0 6px';
          return {
            width: width + 'px',
            height: height + 'px',
            margin: margin,
            borderRadius: '8px'
          }
        } else {
          let width = window.innerWidth - 24.5;
          let height = width * 1.31;
          let padding = '0 6px';
          return {
            width: width + 'px',
            height: height + 'px',
            padding: padding,
            borderRadius: '8px'
          }
        }
      },
      contentSlideStyle() {
        if (window.innerWidth < 500) {
          return {
            width: '100%',
            height: this.slickImg.height
          }
        } else {
          return {
            width: '1106px',
            height: this.slickImg.height
          }
        }
      }
    },
    methods: {
      clickCategory() {
        let id = {
          59: 1,
          60: 2,
          61: 3
        }[this.detail.category2];
        this.routerPush(`/theme_market?tab=${id}`);
      },
      clickReview() {
        if(window.innerWidth < 1024) {
          this.$refs.mtab.selectedItem = 1;
          location.replace('#mtabs');
        } else {
          this.$refs.tab.selectedItem = 1;
          location.replace('#tabs');
        }
      },
      showMobilePreview() {
        window.name = 'preview_parent';
        let popup = window.open('', 'previewPopup', 'width=360, height=640, top=300, left=300, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=yes, scrollbar=no');
        popup.location.href = this.detail.preview_url;
      },
      preview(device) {
        console.log(device)
        location.href = this.detail.preview_url;
      },
      next() {
        this.$refs.slick.next();
      },

      prev() {
        this.$refs.slick.prev();
      },
      // 상품 상세
      getProductDetail() {
        let request = this.request.user;
        let url = `launchpack/v1/theme/${this.$route.query.id}`;
        if(!this.isLogin) {
          request = this.$axios;
          url = 'public/' + url;
        }

        request.get(url).then(async res => {
          if (res.status === 200) {
            if (res.data.preview_url && res.data.preview_url.indexOf('demo') === -1) {
              let key = res.data.preview_url.split('.')[0].replace('https://', '');
              res.data.preview_url += `/home?demo_test=${key}`;
            }

            //res.data.img = res.data.imgs[0];
            // 대표이미지 제외
            //res.data.imgs = res.data.imgs.splice(1);
            // 슬라이드쇼 반복을 위해서 concat
            // res.data.imgs = res.data.imgs.concat(res.data.imgs);
            let detail = res.data;
            if (!detail.service_use_price) {
              detail.service_use_price = {
                id: 1,
                name: "서비스 운영 이용료",
                desc: null,
                price: 300000
              }
            }
            await this.setServiceUsePrice(detail);
            this.detail = detail;
          }
        }).catch(()=>{

        });
      },
      async setServiceUsePrice(detail) {
        let pack_name = '';
        let item = find(detail.params, 'name', '주문전환');
        if (item) {
          if (item.value_select && item.value_select.length > 0) {
            let pack_item = find(item.choice_items, 'id', item.value_select[0]);
            if (pack_item) {
              pack_name = pack_item.name;
            }
          }
          let query = '';
          if (pack_name) {
            query = `?pack=${this.convertPack(pack_name)}`
          }
          await this.$axios.get(`public/launchpack/service_use_price/info${query}`).then(res => {
            detail.service_use_price = res.data;
          })
        }
      },
      convertPack(name) {
        switch (name) {
          case '':
            return '';
          case '전화연결':
            return 'call';
          case '아웃링크':
            return 'outlink';
          case '상품배송주문':
            return 'delivery';
          case '모임신청':
            return 'meet';
          case '상담신청':
            return 'counsel';
          case '견적요청':
            return 'estimate';
          case '사용권':
            return 'license';
          case '컨텐츠다운로드주문':
            return 'commerce';
          case '숙박예약':
            return 'booking';
          case '서비스예약':
            return 'reservation';
        }
      },
      imgField(img, device) {
        let style = {
          backgroundImage: `url(${this.image(img)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        };
        if (device === 'mobile') {
          style.height = (window.innerWidth * 3/4).toString() + 'px';
        }
        return style;
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .pc
    .product-wrapper
      display grid
      grid-gap 0 72px
      grid-template-columns repeat(2, 1fr)

    .card-img
      position relative
      width 516px
      height 387px
      border-radius 8px
      .card-exts
        position absolute
        border-radius 6px
        top 8px
        right 8px
        z-index 1
        padding 7px 10px
        background-color $main
        display flex
        align-items center
        gap 8px
        img
          width 24px
          height 24px

    .box-right
      border 1px solid $gray2
      padding 32px
      border-radius 12px

    .img-partner
      width 40px
      height 40px
      border-radius 100%

  .mobile
    .card-img
      position relative
      width 100%
      border 1px solid $gray3
      .card-exts
        position absolute
        border-radius 6px
        top 4px
        right 4px
        z-index 1
        padding 7px 10px
        background-color $main
        display flex
        align-items center
        gap 12px
        img
          width 24px
          height 24px

    .box-right
      border 1px solid $gray2
      padding 12px
      border-radius 6px

    .img-partner
      width 32px
      height 32px
      border-radius 100%


  .lp-divider-gray3
    border-bottom 1px solid $gray3
  .lp-divider-gray3-12
    border-bottom 12px solid $gray3

  .button-group-preview
    display flex
    margin-top 20px
    gap 12px

    a
    .button
      width 100%
      flex 1
      display flex
      align-items center

    img
      filter invert(54%) sepia(46%) saturate(5884%) hue-rotate(360deg) brightness(100%) contrast(110%)

  .border-top-gray-3
    width 100%
    border-top 1px solid $gray3
    margin 12px 0
</style>

<style lang="stylus">
  @import '~assets/css/lp_main'

  @media (max-width: 1024px)
    .tablet-preview
      display block

    .mobile-preview
      display none

  @media (max-width: 640px)
    .tablet-preview
      display none

    .mobile-preview
      display block
</style>
